import { render, staticRenderFns } from "./donors.vue?vue&type=template&id=51ca827d&"
import script from "./donors.vue?vue&type=script&lang=js&"
export * from "./donors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports